import type Phaser from 'phaser';
import { getFieldBottomY } from '../constants/field';
import { getEntityScale } from '../constants/scale';
import { PLAYER_TORSO_HALF_HEIGHT } from '../entities/Player';

// Граница движения ИГРОКА: раньше игрок мог опускаться на +40 НИЖЕ границы поля
// (PLAYER_BOTTOM_MARGIN). С PLAYER_SCALE=0.5 + адаптивный entityScale игрок маленький,
// и этот выход = игрок torchит за поле в зону слотов оружия. Теперь maxY такой что
// **torso bottom** игрока совпадает с границей поля — игрок целиком в поле.
// Spawn враgов через getReachableSpawnYMax сжимается соответственно (см. GameScene).
export function isMobile(): boolean {
  return !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}

export function getSafeMaxY(scene: Phaser.Scene): number {
  return getFieldBottomY(scene) - PLAYER_TORSO_HALF_HEIGHT * getEntityScale(scene);
}

// Граница спавна врагов = нижняя граница поля. Сведено к одному источнику с
// getFieldBottomY — раньше было двойное определение.
export function getSafeSpawnMaxY(scene: Phaser.Scene): number {
  return getFieldBottomY(scene);
}
